import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'betRank',
})
export class BetRankPipe implements PipeTransform {
  runnerOrders = {
    1: 'I',
    2: 'II',
    3: 'III',
    4: 'IV',
    5: 'K',
  };
  runnerOrdersQuinte = {
    1: 'I',
    2: 'II',
    3: 'III',
    4: 'IV',
    5: 'V',
    6: 'K',
  };

  transform(value: any, betSlip): any {
    if (betSlip.bet === 'ita') {
      return this.runnerOrders[2];
    } else if (betSlip.bet === 'trita') {
      return this.runnerOrders[3];
    } else if (betSlip.bet === 'quinella') {
      const runnerOrderOne = betSlip.bets.filter((r) => r.runnerOrder === 1);
      return runnerOrderOne
        ? value === 1
          ? this.runnerOrders[1]
          : this.runnerOrders[5]
        : this.runnerOrders[5];
    } else if (
      [
        'trifecta',
        'pmu_tierce',
        'pmu_quarte_plus',
        'pmu_tierce_standard',
        'pmu_quarte_plus_standard',
        'pmu_super_4',
        'exacta',
        'trio',
      ].includes(betSlip.bet)
    ) {
      return this.runnerOrders[value];
    } else if (['pmu_quinte_plus'].includes(betSlip.bet)) {
      return this.runnerOrdersQuinte[value];
    } else {
      return this.runnerOrders[1];
    }
  }
}
@Pipe({
  name: 'betRank2',
})
export class BetRank2Pipe implements PipeTransform {
  runnerOrders = {
    1: 'I',
    2: 'II',
    3: 'III',
    4: 'IV',
    5: 'K',
    6: '→',
  };
  runnerOrdersQuinte = {
    1: 'I',
    2: 'II',
    3: 'III',
    4: 'IV',
    5: 'V',
    6: 'K',
  };

  transform(value: any, bet: string, runnerOrders: any[]): any {

    if (['pmu_tierce_standard', 'pmu_quarte_plus_standard', 'pmu_quinte_plus_standard'].includes(bet)) {
      return this.runnerOrders[6];
    }
    if (!runnerOrders?.length && bet != 'pmu_quinte_plus')
      return value >= 1 ? this.runnerOrders[value] : this.runnerOrders[1];
    if (bet === 'ita') {
      return this.runnerOrders[2];
    } else if (bet === 'trita') {
      return this.runnerOrders[3];
    } else if (bet === 'quinella') {
      const runnerOrderOne = runnerOrders.filter((r) => r.runnerOrder === 1);
      return runnerOrderOne
        ? value === 1
          ? this.runnerOrders[1]
          : this.runnerOrders[5]
        : this.runnerOrders[5];
    } else if (
      ['trifecta', 'pmu_tierce', 'pmu_quarte_plus', 'pmu_super_4', 'exacta', 'trio'].includes(
        bet
      )
    ) {
      return this.runnerOrders[value];
    } else if (['pmu_quinte_plus'].includes(bet)) {
      return this.runnerOrdersQuinte[value];
    } else {
      return this.runnerOrders[1];
    }
  }
}
